export default {
  routes: [
    {
      name: 'doctors',
      path: '/directory/doctors',
      component: () => import('./views/TheDoctors.vue'),

    },

    {
      name: 'doctor',
      path: '/directory/doctors/:uuid',
      component: () => import('./views/TheDoctor.vue'),
    },
  ]
}
